/**
 * Toggles html[data-viewport-compact] when the visible viewport is short or heavily zoomed,
 * so fixed headers and footers yield space for magnified / reflow layouts (WCAG 1.4.10).
 */
(function () {
  "use strict";

  function inThemeEditor() {
    return document.documentElement.classList.contains("shopify-design-mode");
  }

  function isCompact() {
    var vv = window.visualViewport;
    var short = false;
    if (vv) {
      short = vv.height < 540;
      if (!short && typeof vv.scale === "number" && vv.scale >= 3) return true;
    } else {
      short = window.innerHeight < 540;
    }
    return short;
  }

  function refresh() {
    var root = document.documentElement;
    if (inThemeEditor()) {
      root.removeAttribute("data-viewport-compact");
      return;
    }
    root.toggleAttribute("data-viewport-compact", isCompact());
  }

  refresh();
  document.addEventListener("DOMContentLoaded", refresh);
  window.addEventListener("resize", refresh);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", refresh);
    window.visualViewport.addEventListener("scroll", refresh);
  }
})();
